<template>
  <v-layout justify-end>
    <v-btn outline slot="activator" color="primary" class="mb-2" @click="open">
       <v-icon dark left>note_add</v-icon>New Item
    </v-btn>
    <v-dialog v-model="localDialog" persistent max-width="1500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container fluid>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex>
                  <v-text-field
                    label="Name"
                    v-model="local.name"
                    :rules="generalRules"
                    required>
                  </v-text-field>
                  <v-select
                    :items="animationTypes"
                    v-model="local.animationType"
                    label="Select Animation Type"
                    chips
                    persistent-hint>
                  </v-select>
                  <v-text-field
                    label="Start Time"
                    v-model="local.startTime"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    label="End Time"
                    v-model="local.endTime"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.duration"
                    label="Duration (sec)"
                    type="number">
                  </v-text-field>
                  <v-text-field
                    v-model="local.textColor"
                    label="Text Color"
                    type="text">
                  </v-text-field>
                  <v-textarea
                    label="Text"
                    v-model="local.text">
                  </v-textarea>
                </v-flex>
                <v-spacer></v-spacer>
                <v-divider vertical></v-divider>
                <v-spacer></v-spacer>
                <v-flex>
                  <popover :always="true">
                    <h3>Position of Origin</h3>
                  </popover>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.positionOfOrigin.X"
                        label="Dimension X"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.positionOfOrigin.Y"
                        label="Dimension Y"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.positionOfOrigin.Z"
                        label="Dimension Z"
                        type="number">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <popover :always="true">
                    <h3>Rotation of Origin</h3>
                  </popover>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.rotationOfOrigin.X"
                        label="Dimension X"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.rotationOfOrigin.Y"
                        label="Dimension Y"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.rotationOfOrigin.Z"
                        label="Dimension Z"
                        type="number">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <popover :always="true">
                    <h3>Scale of Origin</h3>
                  </popover>
                  <v-layout>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.scaleOfOrigin.X"
                        label="Dimension X"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.scaleOfOrigin.Y"
                        label="Dimension Y"
                        type="number">
                      </v-text-field>
                    </v-flex>
                    <v-spacer/>
                    <v-flex xs3>
                      <v-text-field
                        v-model="local.scaleOfOrigin.Z"
                        label="Dimension Z"
                        type="number">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-spacer/>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outline @click="close">Cancel</v-btn>
          <v-btn color="primary" @click="save">
            <v-flex v-if="this.saving">
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
            </v-flex>
            <v-flex v-else>Save</v-flex>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ImageUploader from '../uploader/imageUploader'
import FileUploader from '../uploader/fileUploader'
import {db} from '../../../firebaseDB'

export default {
  name: 'addNew',
  components: { ImageUploader, FileUploader },
  data: () => ({
    valid: true,
    errorMsg: '',
    saving: false,
    generalRules: [
      v => !!v || 'This field is required'
    ],
    positiveNumber: [
      v => v >= 0.01 || 'This field should be greater than 0'
    ],
    animationTypes: [],
    local: {
      id: '',
      name: '',
      animationType: '',
      startTime: 0,
      endTime: 0,
      duration: 0,
      textColor: '',
      text: '',
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      }
    }
  }),
  props: {
    dialog: '',
    editedID: '',
    info: {
      id: null,
      name: '',
      animationType: '',
      startTime: 0,
      endTime: 0,
      duration: 0,
      textColor: '',
      text: '',
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      }
    }
  },
  created () {
    db.ref('assets/asset_data/dynamicText')
      .once('value')
      .then(snapshot => {
        Object.keys(snapshot.val())
          .forEach(k => this.sounds.push({
            id: k,
            name: snapshot.val()[k].name || k
          }))
      })
      .catch(error => {
        console.log('Error - ' + error.message)
      })
  },
  computed: {
    formTitle () {
      return this.editedID === -1 ? 'New DS-Dynamic Text' : 'Edit DS-Dynamic Text'
    },
    localDialog: {
      get: function () {
        return this.dialog
      }
    }
  },
  watch: {
    info (val) {
      this.local = Object.assign({}, val)
    },
    dialog (val) {
      if (!val) {
        this.saving = false
        this.resetForm()
      }
    }
  },
  methods: {
    resetForm () {
      this.$refs.form.resetValidation()
    },
    validateForm () {
      return this.$refs.form.validate()
    },
    open () {
      this.$emit('open')
    },
    close () {
      this.$emit('close')
    },
    save () {
      if (this.validateForm()) {
        this.saving = true
        this.$emit('save', this.local)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assets/add-new/addDynamicText.vue